<div class="sign-in-container">
	<div class="form-container">
		<form [formGroup]="form" (ngSubmit)="setNewPassword()">
			<img class="h-[100px] w-auto mx-auto" src="/assets/images/logo.jpg" alt="Logo">
			<h1 class="my-1 mt-4 text-center">Welcome to Stars & Stripes Seed Co. <br>Sign In to access your dashboard
			</h1>
			<p-divider></p-divider>
			<div class="flex flex-col gap-4">
				<div class="flex flex-col gap-2">
					<label for="password">Password</label>
					<input pInputText id="password" type="password" formControlName="password" required />
					<small class="error" *ngIf="password.invalid && (password.dirty || password?.touched)">
						<span *ngIf="password?.errors?.['required']">* Password is required </span>
						<span *ngIf="password?.errors?.['minlength']">* Password should be characters long. </span>
					</small>
				</div>
				<div class="flex flex-col gap-2">
					<label for="password">Confirm Password</label>
					<input pInputText id="password" type="password" formControlName="confirm_password" required />
					<small class="error"
						*ngIf="confirmPassword.invalid && (confirmPassword.dirty || confirmPassword?.touched)">
						<span *ngIf="confirmPassword?.errors?.['required']">* Confirm Password is required </span>
						<span *ngIf="confirmPassword?.errors?.['matched']">* Password and Confirm Password not matched
						</span>
					</small>
				</div>
				<button type="submit" class="w-full" label="Submit" pButton></button>
			</div>
		</form>
	</div>
</div>